import { init, getCurrentUuid as getUuid, getCurrentData as getDeviceData, uploadData as upload, getDeviceId, getAllDeviceData, getLocation, getSmDeviceId, getAfiDataInfo, getTmx } from './main'; // import { getSmDeviceId } from './module'

export default {
  init: init,
  getUuid: getUuid,
  getDeviceData: getDeviceData,
  upload: upload,
  getDeviceId: getDeviceId,
  getAllDeviceData: getAllDeviceData,
  getLocation: getLocation,
  getSmDeviceId: getSmDeviceId,
  getAfiDataInfo: getAfiDataInfo,
  getTmx: getTmx
};